module.exports = __webpack_public_path__ + "img/nature_icon.7ffdf1ea.png";